import React, { forwardRef, ReactNode } from 'react';
import clsx from 'clsx';
import styles from './ModuleContainer.module.scss';
import { ModuleSpacing } from '~/lib/data-contract';
import { MaxWidth } from '~/shared/components/MaxWidth';
import { Gutter } from '~/shared/components/Gutter';
import { useModuleTheme } from '../../hooks/useModuleTheme';

export type ModuleContainerProps = {
    backgroundColor?: string;
    spacingTop?: ModuleSpacing['spacingTop'];
    spacingBottom?: ModuleSpacing['spacingBottom'];
    fullWidth?: boolean;
    hasGutter?: boolean;
    children: ReactNode;
    className?: string;
    style?: React.CSSProperties;
    id?: string;
};

export const ModuleContainer = forwardRef<HTMLDivElement, ModuleContainerProps>((props, ref) => {
    const {
        fullWidth,
        children,
        spacingTop = 'default',
        spacingBottom = 'default',
        className,
        hasGutter = true,
        backgroundColor: initialBackgroundColor,
        style,
        id,
    } = props;

    const { backgroundColor } = useModuleTheme({ backgroundColor: initialBackgroundColor });
    const content = hasGutter ? <Gutter>{children}</Gutter> : children;

    const containerClass = clsx(
        styles.module,
        styles[`top-${spacingTop}`],
        styles[`bottom-${spacingBottom}`],
        className,
    );

    return (
        <div
            id={id}
            ref={ref}
            className={containerClass}
            style={{
                backgroundColor: backgroundColor || undefined,
                ...style,
            }}
        >
            {fullWidth ? content : <MaxWidth>{content}</MaxWidth>}
        </div>
    );
});
